import { createSlice } from "@reduxjs/toolkit";

const intialLoginUserState = {
  loginUserState: {},
  isProxyLogin: false,
};

const users = createSlice({
  name: "loginUser",
  initialState: intialLoginUserState,
  reducers: {
    getLoginUsersSlice() {},
    getLoginUserData(state, action) {
      state.loginUserState = action.payload;
    },
    getIsProxyLogin(state, action) {
      state.isProxyLogin = action.payload || false;
    },
    fetchSuccess() {
      // state.loginUserState = action.payload;
    },
    logoutUsersSlice() {},
    logoutUser(state) {
      state.loginUserState = {};
      state.isProxyLogin = false;
    },
    updateDateFormat(state, action) {
      state.loginUserState.dateFormat = action.payload;
    },
    updateWorkingDays(state, action) {
      state.loginUserState.workingDays = action.payload;
    },
    updateShowKPITemplateModal(state, action) {
      state.loginUserState.showKPITemplateModal = action.payload;
    },
  },
});
export const loginUserAction = users.actions;
export default users.reducer;
